"use strict";
// Copyright 2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScreenShareStreamingEvent = void 0;
var ScreenShareStreamingEvent;
(function (ScreenShareStreamingEvent) {
    ScreenShareStreamingEvent["EndedEvent"] = "ended";
    ScreenShareStreamingEvent["MessageEvent"] = "message";
})(ScreenShareStreamingEvent = exports.ScreenShareStreamingEvent || (exports.ScreenShareStreamingEvent = {}));
exports.default = ScreenShareStreamingEvent;
//# sourceMappingURL=ScreenShareStreamingEvent.js.map